// extracted by mini-css-extract-plugin
module.exports = {"emailPasswordContainer":"asm_ahv","signUpSignInSwitchText":"asm_ah7","linkText":"asm_t1","terms":"asm_z0"};